export const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.swandevnet.com"
    : "http://localhost:3001";

// Base for the Grubwick restaurant/menu API (/gw/*). The browser calls this host
// directly (cross-origin): the backend now verifies Supabase JWTs and sends CORS
// headers for our allowed origins (localhost:1234 in dev, the deployed UI in prod),
// so no same-origin proxy is needed. All /gw calls go through gwFetch (src/api/client.ts),
// which attaches the Supabase access token.
export const GW_API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.swandevnet.com"
    : "http://localhost:8000";

// Supabase project config. Read from the build environment (Parcel inlines process.env.*).
// The publishable key (sb_publishable_…, or the legacy "anon" JWT — either works with
// createClient) is public-safe to ship in the browser. SUPABASE_URL is fixed for this
// project, so it defaults; the key must be supplied via .env (see .env.example).
export const SUPABASE_URL =
  process.env.SUPABASE_URL ?? "https://zsjyppcnigjguahvvdnp.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY =
  process.env.SUPABASE_PUBLISHABLE_KEY ?? process.env.SUPABASE_ANON_KEY ?? "";
